import { render } from "./AddDepot.vue?vue&type=template&id=b502d5b8&ts=true"
import script from "./AddDepot.vue?vue&type=script&lang=ts"
export * from "./AddDepot.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__